import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";

import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import CancelIcon from '@mui/icons-material/Cancel';
import moment from "moment";
import { images, truncateString } from "../../../../../constants";
import { getCreatedByDisplayFromQT } from "../../../../../utils/createdByUtils";

const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  setSelectedAudioFile,
  setSelectedImage,
  handleNavigateToDetails,
  columnWidths,
  organizationsData = [],
}) => {

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        id={labelId}
        align="left"
        scope="row"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.title || 280,
          minWidth: columnWidths?.title || 100,
          maxWidth: columnWidths?.title || 350,
        }}
        title={row?.title}
      >
        {row?.title && truncateString(row?.title, 40)}
      </TableCell>
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 90,
          minWidth: columnWidths?.photo || 75,
          maxWidth: columnWidths?.photo || 150,
        }}
        onClick={() => {
          setSelectedImage(
            row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        <img
          src={row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo}
          alt="table image"
          style={{ width: 45, height: 40 }}
        />
      </TableCell>
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.audio || 90,
          minWidth: columnWidths?.audio || 90,
          maxWidth: columnWidths?.audio || 90,
        }}
        onClick={() => {
          if (row?.processedAudioUrl || row?.audioUrl) {
            setSelectedAudioFile(row?.processedAudioUrl || row?.audioUrl);
            handleAudioModalOpen();
          }
        }}
      >
        {(row?.processedAudioUrl || row?.audioUrl) ? (
          <PlayCircleFilledWhiteOutlinedIcon
            fontSize="large"
            style={{ color: "#00A7CD" }}
          />
        ) : (
          <CancelIcon
            fontSize="large"
            style={{ color: "#D32F2F" }}
          />
        )}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 100,
          maxWidth: columnWidths?.createdAt || 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.createdAt &&
          moment
            .unix(row?.createdAt?.seconds)
            .format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdBy || 130,
          minWidth: columnWidths?.createdBy || 100,
          maxWidth: columnWidths?.createdBy || 180,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {(() => {
          // Resolve org name when createdByData is missing (org creators aren't
          // batch-fetched in the provider). Falls back to the shared helper,
          // then to the raw id.
          if (!row?.createdByData && row?.createdBy) {
            const org = organizationsData?.find((o) => o?.id === row.createdBy);
            if (org?.name) return org.name;
          }
          return getCreatedByDisplayFromQT(row);
        })()}
      </TableCell>

      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.narrator || 130,
          minWidth: columnWidths?.narrator || 100,
          maxWidth: columnWidths?.narrator || 180,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.narratorData ? row?.narratorData?.userName : row.narrator}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.status || 150,
          minWidth: columnWidths?.status || 100,
          maxWidth: columnWidths?.status || 180,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.status}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.draftStatus || 120,
          minWidth: columnWidths?.draftStatus || 100,
          maxWidth: columnWidths?.draftStatus || 180,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.isDraft === true ? "Draft" : "Finished"}
      </TableCell>
      {/* Reported Status column temporarily removed for performance. Restore
          alongside the reportedStatus fetch in QuickTalesProvider.handleGetGAQuickTales
          and the head cell in constants (GAQuicktalesTableHeadCells). */}
      {/* <TableCell
        align="left"
        style={{
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.reportedStatus || 160,
          minWidth: columnWidths?.reportedStatus || 100,
          maxWidth: columnWidths?.reportedStatus || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.reportedStatus}
      </TableCell> */}
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 200,

          minWidth: columnWidths?.id || 100,
          maxWidth: columnWidths?.id || 300,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row?.id}
      >
        {row?.id}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.visionIndexedAt || 170,
          minWidth: columnWidths?.visionIndexedAt || 100,
          maxWidth: columnWidths?.visionIndexedAt || 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row?.visionIndexedAt &&
          moment
            .unix(row?.visionIndexedAt?.seconds)
            .format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  //paddingLeft: 10,
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  //paddingLeft: 10,
};
